import React from 'react';

import classNames from 'classnames';

import ToggleInput from 'CommonComponents/ToggleInput';

// Green "Use as budget tag" switch. When it cannot be used (codeset not
// eligible, or no permission) the track and label are greyed out.
export default function BudgetTagToggle({ unavailable, disabled, ...props }) {
    return (
        <div className={classNames('tw-inline-flex', { 'tw-opacity-50 tw-cursor-not-allowed [&_label]:tw-cursor-not-allowed': unavailable })}>
            <ToggleInput noBottomSpacing checkedClassName="peer-checked:tw-bg-green" disabled={unavailable || disabled} {...props} />
        </div>
    );
}
